const rawKey = import.meta.env.VITE_STATSIG_CLIENT_KEY

if (typeof rawKey !== "string" || rawKey === "") {
	throw Error("VITE_STATSIG_CLIENT_KEY was not provided")
}

export const gatingClientKey = rawKey
